/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { TimeComponentLayersStack } from './TimeComponentLayersStack';
import { TimeComponentVerticalGridlines } from './TimeComponentVerticalGridlines';
import { TimeComponentHorizontalTimeAxisLabel } from './TimeComponentHorizontalTimeAxisLabel';
import { timeAxisLabelsStyles } from './themes/TimeComponentStyles.css';

type Props = {
  font: { fontSize?: string; fontWeight?: string };
  labelPosition: 'start' | 'center';
  labels: string[];
  labelTicks: number[];
  labelPositions: number[];
  isLabelTruncated: boolean[];
  isIntervalStartTruncated: boolean;
  intervalWidths: number[];
  majorGridTicksPos?: number[];
  minorGridTicksPos?: number[];
  isRTL: boolean;
  width: number;
  height: number;
};

export function TimeComponentHorizontalTimeAxis({
  font,
  labelPosition,
  labels,
  labelTicks,
  labelPositions,
  isLabelTruncated,
  isIntervalStartTruncated,
  intervalWidths,
  majorGridTicksPos,
  minorGridTicksPos,
  isRTL,
  width,
  height
}: Props) {
  return (
    <TimeComponentLayersStack width={`${width}px`} height={`${height}px`}>
      <div class={timeAxisLabelsStyles.base}>
        {labels.map((text, i) => (
          <TimeComponentHorizontalTimeAxisLabel
            key={labelTicks[i]}
            font={font}
            label={text}
            labelPosition={labelPosition}
            x={labelPositions[i]}
            y={0}
            width={intervalWidths[i]}
            isTruncated={isLabelTruncated[i]}
            isStartIntervalTruncated={i === 0 ? isIntervalStartTruncated : false}
            isRTL={isRTL}
          />
        ))}
      </div>
      {minorGridTicksPos && (
        <TimeComponentVerticalGridlines
          width={width}
          height={height}
          positions={minorGridTicksPos}
          variant="minor"
        />
      )}
      {majorGridTicksPos && (
        <TimeComponentVerticalGridlines
          width={width}
          height={height}
          positions={majorGridTicksPos}
          variant="major"
        />
      )}
    </TimeComponentLayersStack>
  );
}
